module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_phone-d687582e9dbf28def199e213f91bc588.svg";